var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 11.375V10.2917C10.8334 9.71703 10.6051 9.16593 10.1988 8.7596C9.79248 8.35327 9.24138 8.125 8.66675 8.125H4.33341C3.75878 8.125 3.20768 8.35327 2.80135 8.7596C2.39502 9.16593 2.16675 9.71703 2.16675 10.2917V11.375",
    stroke: "#BBBBBB",
    strokeWidth: 0.541667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49992 5.95833C7.69654 5.95833 8.66659 4.98828 8.66659 3.79167C8.66659 2.59505 7.69654 1.625 6.49992 1.625C5.3033 1.625 4.33325 2.59505 4.33325 3.79167C4.33325 4.98828 5.3033 5.95833 6.49992 5.95833Z",
    stroke: "#BBBBBB",
    strokeWidth: 0.541667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.c4502738ae356b19e02071d43317dfb5.svg";
export { ForwardRef as ReactComponent };